import { Yield } from '../../abacus/interfaces/yield.interface'

export const benefitYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
